{
    "ManageCustomRoles_Title": "Ajouter un modèle de rôle personnalisé",
    "ManageCustomRoles_Role_Name": "Nom du modèle de rôle",
    "ManageCustomRoles_Description": "Description",
    "ManageCustomRoles_Cancel": "Annuler",
    "ManageCustomRoles_Help": "Aide",
    "ManageCustomRoles_Save": "Économiser",
    "NAME": "ManageCustomRoles"
}